export default {
  unavailable: {
    title: 'Le fatture per i clienti non sono disponibili',
    description:
      "Gli ospiti che ordinano nei tuoi ristoranti non possono richiedere una fattura, quindi non c'è nulla da configurare qui. Le ricevute degli ordini e le fatture emesse dal tuo provider non sono interessate.",
  },
};
